import React from 'react'
import { getFormattedTime } from 'helpers/time-format'
import { TRAILER_TITLE } from 'constant'
import { formatPhoneNumber } from './helpers'
import { CYCLE_CHANGE_REGEXP } from './constants'

export const getServicesDisplayNames = ({ servicesList = [], catalogRefIds = []} = {}) => {
  const lastListIndex = catalogRefIds.length - 1

  return catalogRefIds.reduce((acc, id, index) => (
    acc.concat(`${servicesList[id]}${index < lastListIndex ? ', ' : ' '}`)
  ), '')
}

export const getSelectedVehicle = ({ vehicles = [], activeVehicleId = [], isTrailer }) =>
  isTrailer ? TRAILER_TITLE :
    (vehicles.filter(({ userVehicleId }) =>
      userVehicleId === activeVehicleId)[0] || {}).vehicleNickname

export const getSelectedTime = ({ date, time: { displayName, value } = {}} = {}) =>
  displayName && value ? {
    selectedDateTime:
      `${value.match(CYCLE_CHANGE_REGEXP) ? value.toLowerCase() : displayName.toLowerCase()}, ${getFormattedTime(date)}`
  } : {}

// eslint-disable-next-line react/prop-types
export const getSelectedContactInfo = ({ firstName, lastName, email, phoneNumber }) =>
  <React.Fragment>
    {firstName} {lastName}
    <br />
    {formatPhoneNumber(phoneNumber)}
    <br />
    {email}
  </React.Fragment>
